import 'babel-polyfill';
import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import MedicineService from '../../../services/medicineService';
import Translate from '../../../common/functions/translate';
import { UserNotificationModel } from "../../../models/user/userNotificationModel";
import { NotificationScheduleType, NotificationAlarmType, NotificationFrequency, MinutesForIntake, DayOfWeekOneLetterAbbr, DayOfWeekThreeLetterAbbr } from "../../../common/enums";
import { DropdownModel } from "../../../models/dropdownModel";
import { enumToDropdownArray, weekDayEnumToObjArray, getFrequencyCounterLabel, fomatDateAsString, fomatTimeAsString, fomatDateTimeAsString, getNotificationSummary, formatAlarmTime, fomatDateAsStringNotifications } from '../../../common/functions/helperFunctions';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import { TimePicker, DatePicker } from '@material-ui/pickers';
import { Checkbox } from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core';
import Growl from '../../../common/components/alertMessage/growl';
import InputLabel from '@material-ui/core/InputLabel';
import * as Constants from '../../../common/constants';
import UserService from "../../../services/userService";
import Spinner from '../../../common/components/spinner/spinner';

import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import TagFacesIcon from '@material-ui/icons/TagFaces';

interface IProps {
  selectedUserNotification: UserNotificationModel,
  isVisible: boolean,
  cancelClick: any,
  saveClick: any,
  //userMedicineHistoryId: number,
  lang: string
}

interface IState {
  isLoading: boolean;
  currentUserNotification: UserNotificationModel,
  notificationScheduleTypeDropdown: Array<DropdownModel>;
  notificationAlarmTypeDropdown: Array<DropdownModel>;
  notificationFrequencyDropdown: Array<DropdownModel>;
  isFrequencyButtonDisabled: boolean;
  summaryContent: string;
  //isEndDateDisabled: boolean;
  caretakers: Array<DropdownModel>;
  minutesForIntake: Array<DropdownModel>;
  weekDayChips: Array<any>;
  isWeekdaySelected: boolean;
}


class UserNotificationAddEditDialog extends React.Component<IProps, IState> {
  medicineService = new MedicineService();
  growl: any;
  userService = new UserService();
  today = new Date();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      currentUserNotification: props.selectedUserNotification,
      notificationScheduleTypeDropdown: new Array<DropdownModel>(0),
      notificationAlarmTypeDropdown: new Array<DropdownModel>(0),
      notificationFrequencyDropdown: new Array<DropdownModel>(0),
      isFrequencyButtonDisabled: false,
      //isEndDateDisabled: false,
      summaryContent: '',
      caretakers: new Array<DropdownModel>(0),
      minutesForIntake: new Array<DropdownModel>(0),
      weekDayChips: new Array<any>(0),
      isWeekdaySelected: false
    }
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });
    this.userService.getAllCaretakers().then(
      (data: any) => {
        if (data) {
          let firstElement: Array<DropdownModel> = new Array<DropdownModel>(0);
          if (data && data.length > 0) {
            firstElement = [{ label: Translate('Select'), value: 0 }];
          }
          this.setState({ caretakers: firstElement.concat(data), isLoading: false }, () => this.initData());
        }
      })
      .catch(error => {
        this.setState({
          isLoading: false
        });
        this.growl.show({ severity: 'error', summary: error.message });
      });
  }

  initData() {
    this.setState({
      isLoading: true
    });

    const notificationAlarmTypeDropdown: Array<DropdownModel> = enumToDropdownArray(NotificationAlarmType, true);
    const notificationScheduleTypeDropdown: Array<DropdownModel> = enumToDropdownArray(NotificationScheduleType, true);
    const notificationFrequencyDropdown: Array<DropdownModel> = enumToDropdownArray(NotificationFrequency, true);
    const minutesForIntake: Array<DropdownModel> = enumToDropdownArray(MinutesForIntake, true);
    const weekDayObjArray: Array<any> = weekDayEnumToObjArray(DayOfWeekOneLetterAbbr, true, false, false);


    this.setState({
      notificationAlarmTypeDropdown: notificationAlarmTypeDropdown,
      notificationScheduleTypeDropdown: notificationScheduleTypeDropdown,
      notificationFrequencyDropdown: notificationFrequencyDropdown,
      minutesForIntake: minutesForIntake,
      isLoading: false,
      isFrequencyButtonDisabled: (this.state.currentUserNotification.notificationScheduleTypeId === 1) ? true : false,
      weekDayChips: weekDayObjArray
    });

    this.handleSummaryContent(this.state.currentUserNotification);
  }

  handleSummaryContent(currentUserNotification: UserNotificationModel) {
    let summaryContent = getNotificationSummary(currentUserNotification, this.props.lang);

    this.setState({
      summaryContent: summaryContent
    });
  }

  handleChange = (key, value) => {
    const currentUserNotification: UserNotificationModel = { ...this.state.currentUserNotification };
    currentUserNotification[key] = value;

    if (key === "notificationScheduleTypeId" && value !== this.state.currentUserNotification.notificationScheduleTypeId) {
      let theNextHour: Date = new Date();
      theNextHour.setHours(theNextHour.getHours() + 1, 0)
      currentUserNotification.alarmTime = theNextHour.toUTCString();
    }

    if (key == "caretakerUserId" && !currentUserNotification.minutesForIntake) {
      currentUserNotification.minutesForIntake = 5;
    }

    if (key === "alarmTime") {
      if (this.state.currentUserNotification.notificationScheduleTypeId == NotificationScheduleType.OneTime) {
        let date = new Date(currentUserNotification && currentUserNotification.oneTimeExecutionDate ? currentUserNotification.oneTimeExecutionDate : new Date());
        currentUserNotification.oneTimeExecutionDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), value.getHours(), value.getMinutes()).toUTCString();
      }

      if (this.state.currentUserNotification.notificationScheduleTypeId == NotificationScheduleType.Recurring) {
        let startDate = new Date(currentUserNotification && currentUserNotification.startDate ? currentUserNotification.startDate : new Date());
        currentUserNotification.startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), value.getHours(), value.getMinutes()).toUTCString();
        // if (!this.state.isEndDateDisabled) {
        //   let endDate = new Date(currentUserNotification && currentUserNotification.endDate ? currentUserNotification.endDate : new Date());
        //   currentUserNotification.endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), value.getHours(), value.getMinutes()).toUTCString();
        // }
      }
    }

    if (key === "notificationScheduleTypeId") {
      if (value == NotificationScheduleType.OneTime) {
        currentUserNotification.startDate = undefined;
        currentUserNotification.endDate = undefined;
      }
      if (value == NotificationScheduleType.Recurring) {
        currentUserNotification.oneTimeExecutionDate = undefined;
        // if (this.state.isEndDateDisabled) {
        //   currentUserNotification.endDate = undefined;
        // }
      }
    }

    this.setState({
      currentUserNotification: { ...currentUserNotification },
      isFrequencyButtonDisabled: (currentUserNotification.notificationScheduleTypeId === 1) ? true : false
    });

    this.handleSummaryContent(currentUserNotification);
  };

  handleDateTimeChange = (key, value) => {
    const currentUserNotification: UserNotificationModel = { ...this.state.currentUserNotification };

    let datePart = fomatDateAsString(value);
    let timePart = fomatTimeAsString(new Date(currentUserNotification[key]));

    let newValue = datePart;// + " " + timePart;
    value = new Date(newValue);

    currentUserNotification[key] = value;
    this.setState({
      currentUserNotification: { ...currentUserNotification },
      isFrequencyButtonDisabled: (currentUserNotification.notificationScheduleTypeId === 1) ? true : false
    });

    this.handleSummaryContent(currentUserNotification);
  };

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleSaveButton = event => {
    let currentUserNotification = this.state.currentUserNotification;

    if (currentUserNotification.notificationScheduleTypeId == NotificationScheduleType.Recurring) {
      let startDate = new Date(currentUserNotification && currentUserNotification.startDate ? currentUserNotification.startDate : new Date());
      currentUserNotification.startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0, 0).toUTCString();

      // if (!this.state.isEndDateDisabled) {
      //   let endDate = new Date(currentUserNotification && currentUserNotification.endDate ? currentUserNotification.endDate : new Date());
      //   currentUserNotification.endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59).toUTCString();
      // }
    }

    let result = this.hadleObjectValidation(JSON.parse(JSON.stringify(currentUserNotification)));

    this.growl.show({ severity: 'error', summary: result });

    if (!result) {
      //currentUserNotification.userMedicineHistoryId = this.props.userMedicineHistoryId;
      this.props.saveClick(currentUserNotification);
    }
  }

  setCurrentCronExpression(currentUserNotification: UserNotificationModel) {
    // cronExpression = "* * * * * *" => minute | hour | day | month | weekday | year

    let cronExpression: string;
    if (currentUserNotification.notificationScheduleTypeId === 1) {
      cronExpression: ""
    }
  }

  hadleObjectValidation(currentUserNotification: UserNotificationModel) {
    if (!currentUserNotification.alarmTime) {
      return Translate("Alarm time cannot be empty");
    }

    let alarmTime = formatAlarmTime(currentUserNotification.alarmTime);

    if (currentUserNotification.notificationScheduleTypeId === 1) {
      if (!currentUserNotification.oneTimeExecutionDate) {
        return Translate("Date cannot be empty");
      }

      let currentDateTime = fomatDateTimeAsString(new Date());
      let alarmDate = fomatDateAsStringNotifications(new Date(currentUserNotification.oneTimeExecutionDate));
      let alarmDateTime = alarmDate + " " + alarmTime;

      if (currentDateTime >= alarmDateTime) {
        return Translate("Alarm date and/or time") + " (" + alarmDateTime + ") " + Translate("are lesser than current time")
          + " (" + currentDateTime + ")" + ". " + Translate("Alarm will never execute");
      }

      currentUserNotification.oneTimeExecutionDate = alarmDateTime;
      currentUserNotification.alarmTime = alarmTime;
      currentUserNotification.notificationFrequencyId = undefined;
      currentUserNotification.notificationFrequencyCounter = undefined;
      currentUserNotification.isSingleDailyOccurance = undefined;
      currentUserNotification.startDate = undefined;
      currentUserNotification.endDate = undefined;
      currentUserNotification.dailyFrequencyCounter = undefined;
      currentUserNotification.startTime = undefined;
      currentUserNotification.endTime = undefined;

      return "";
    }
    else {
      if (!currentUserNotification.notificationFrequencyId || currentUserNotification.notificationFrequencyId === -1) {
        return Translate("Please choose frequency");
      }

      if (!currentUserNotification.notificationFrequencyCounter || currentUserNotification.notificationFrequencyCounter < 1) {
        return Translate("Please choose counter");
      }

      if (!currentUserNotification.startDate) {
        return Translate("Start date cannot be empty");
      }

      currentUserNotification.startDate = fomatDateAsString(new Date(currentUserNotification.startDate));
      currentUserNotification.alarmTime = alarmTime;

      if (currentUserNotification.endDate) {
        currentUserNotification.endDate = fomatDateAsString(new Date(currentUserNotification.endDate));

        if (currentUserNotification.endDate < currentUserNotification.startDate) {
          return Translate("Start date is greater than end date");
        }

        if (currentUserNotification.endDate < fomatDateAsString(new Date())) {
          return Translate("End date is lesser than today") + ". " + Translate("Alarm will never execute");
        }
      }

      currentUserNotification.oneTimeExecutionDate = undefined;
      currentUserNotification.dailyFrequencyCounter = undefined;
      currentUserNotification.startTime = undefined;
      currentUserNotification.endTime = undefined;
      currentUserNotification.isSingleDailyOccurance = undefined;

      return ""
    }
  }



  handleWeekdayChipClick = (key) => {
    let weekDayChips: Array<any> = this.state.weekDayChips;
    if (weekDayChips && weekDayChips.length > 0) {

      let clickedIndex = weekDayChips.findIndex(c => c.value === key);

      weekDayChips[clickedIndex].isSelected = !weekDayChips[clickedIndex].isSelected;
      this.setState({
        weekDayChips: weekDayChips
      });
    }
  }

  handleWeekDayCheckBox = (value) => {
    let weekDayChips: Array<any> = this.state.weekDayChips;

    if (weekDayChips && weekDayChips.length > 0) {

      weekDayChips.map(c => c.isSelected = value);

      this.setState({
        weekDayChips: weekDayChips
      });
    }

    this.setState({
      isWeekdaySelected: value
    });
  }

  clearDate = (e) => {
    if (e) {
      e.preventDefault();
    }
    let currentUserNotification = { ...this.state.currentUserNotification }
    currentUserNotification.endDate = undefined;
    this.setState({ currentUserNotification: currentUserNotification });
    this.handleSummaryContent(currentUserNotification);
  }

  render() {
    let { currentUserNotification, notificationFrequencyDropdown, notificationScheduleTypeDropdown,
      notificationAlarmTypeDropdown, isFrequencyButtonDisabled, caretakers, minutesForIntake, isLoading, weekDayChips, isWeekdaySelected } = this.state;

    let FrequencyCounterLabel = getFrequencyCounterLabel(currentUserNotification.notificationFrequencyId, true);

    let oneTimeExecutionElement =
      <>
        <div className="p-col-12 p-md-3">
          <DatePicker
            format={Translate('DateFormat')}
            disabled={!isFrequencyButtonDisabled}
            margin="none"
            label={Translate('Date')}
            value={currentUserNotification.oneTimeExecutionDate ? new Date(currentUserNotification.oneTimeExecutionDate) : new Date()}
            onChange={(e) => this.handleChange('oneTimeExecutionDate', e)}
          />
        </div>
        <div className="p-col-12 p-md-3">
          <TimePicker margin="none"
            ampm={false}
            label={Translate('Alarm Time')}
            disabled={!isFrequencyButtonDisabled}
            value={currentUserNotification.alarmTime ? new Date(currentUserNotification.alarmTime) : new Date()}
            onChange={(e) => this.handleChange('alarmTime', e)}
          />
        </div>
      </>;

    let globalFrequencyElement =
      <>
        <div className="p-col-12 p-md-3" >
          <div>
            <FormControl>
              <InputLabel htmlFor="frequency-label">{Translate('Frequency')}</InputLabel>
              <Select
                disabled={isFrequencyButtonDisabled}
                value={currentUserNotification.notificationFrequencyId ? currentUserNotification.notificationFrequencyId : -1}
                onChange={(e) => this.handleChange('notificationFrequencyId', e.target.value)}
                inputProps={{
                  name: 'frequency',
                  id: 'frequency-label'
                }}>
                {notificationFrequencyDropdown.map(m => <MenuItem key={m.value + 'notType'} value={m.value}>{m.label}</MenuItem>)}
              </Select>
            </FormControl>
          </div>
        </div>
        {/* <div className="p-col-12 p-md-3"> */}
        {currentUserNotification.notificationFrequencyId && currentUserNotification.notificationFrequencyId === 3
          ?
          <div className="p-col-12 p-md-3">
            <label>{Translate('Select all')}</label>
            <div>
              <Checkbox
                style={{ marginRight: 5 }}
                checked={isWeekdaySelected}
                onChange={(e) => this.handleWeekDayCheckBox(e.target['checked'])}
                color="primary"
                inputProps={{
                  name: 'selectAll',
                  id: 'select-all'
                }} />
              <MuiThemeProvider theme={Constants.dataPickerWithChekbox}>
                {weekDayChips && weekDayChips.length > 0
                  ?
                  weekDayChips.map(m =>
                    <Chip
                      clickable={true}
                      style={{ marginRight: 3 }}
                      key={m.value}
                      label={m.label}
                      color={m.isSelected ? "primary" : "default"}
                      onClick={() => this.handleWeekdayChipClick(m.value)}
                    //size="small"
                    //variant="outlined"
                    //className={classes.chip}
                    />
                  )
                  :
                  null}
              </MuiThemeProvider>
            </div>
          </div>
          :
          <div className="p-col-12 p-md-3">
            <TextField
              autoComplete="off"
              type="number"
              label={FrequencyCounterLabel}
              value={currentUserNotification.notificationFrequencyCounter ? currentUserNotification.notificationFrequencyCounter : ''}
              onChange={(e) => this.handleChange('notificationFrequencyCounter', e.target['value'])}
              margin="none"
            />
          </div>}
      </>;

    let dailyFrequencyContainer =
      <div className="p-grid p-fluid p-md-12">
        <div className="p-col-12 p-md-3">
          <DatePicker
            format={Translate('DateFormat')}
            disabled={isFrequencyButtonDisabled}
            margin="normal"
            label={Translate('Start Date')}
            value={currentUserNotification.startDate ? new Date(currentUserNotification.startDate) : new Date()}
            onChange={(e) => this.handleDateTimeChange('startDate', e)}
          />
        </div>
        <div className="p-col-12 p-md-3" style={{ marginTop: 4 }}>
          <label>{Translate('End Date')}</label>
          <div style={{ display: 'flex', alignItems: 'center' }}>

            {/* <Checkbox checked={!isEndDateDisabled} onChange={this.handleEndDateCheckbox} color="primary" /> */}
            <DatePicker
              disabled={isFrequencyButtonDisabled}
              format={Translate('DateFormat')}
              margin="none"
              value={currentUserNotification.endDate ? new Date(currentUserNotification.endDate) : null}
              onChange={(e) => this.handleChange('endDate', e)}
            />
            <div style={{ padding: 5 }}>
              <a href='' onClick={(e) => this.clearDate(e)} >
                <FontAwesomeIcon icon={faTimes} style={{ color: '#808080', fontSize: '1.3em', margin: '0 2px' }} />
              </a>
            </div>
          </div>
        </div>
        <div className="p-col-12 p-md-3">
          <TimePicker margin="none"
            ampm={false}
            label={Translate('Alarm Time')}
            disabled={isFrequencyButtonDisabled ? isFrequencyButtonDisabled : !currentUserNotification.isSingleDailyOccurance}
            value={currentUserNotification.alarmTime ? new Date(currentUserNotification.alarmTime) : new Date()}
            onChange={(e) => this.handleChange('alarmTime', e)}
          />
        </div>
      </div>
      ;

    return (
      <Dialog
        open={this.props.isVisible}
        onClose={this.handleCancelButton}
        fullWidth
      >
        <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{Translate('Alarms')}</Modal.DialogTitle>
        <Modal.DialogContent>
          <div>
            {isLoading ? <Spinner /> : null}
            <Growl ref={(el) => this.growl = el} />
            <div>
              <div className="p-grid p-fluid p-md-12">
                <div className="p-col-12 p-md-3">
                  <FormControl>
                    <InputLabel htmlFor="notification-alarm-label">{Translate('Notification Type')}</InputLabel>
                    <Select
                      value={currentUserNotification.notificationAlarmTypeId ? currentUserNotification.notificationAlarmTypeId : -1}
                      onChange={(e) => this.handleChange('notificationAlarmTypeId', e.target.value)}
                      inputProps={{
                        name: 'notificationAlarmType',
                        id: 'notification-alarm-label'
                      }}>
                      {notificationAlarmTypeDropdown.map(m => <MenuItem key={m.value + 'notType'} value={m.value}>{m.label}</MenuItem>)}
                    </Select>
                  </FormControl>
                </div>
                <div className="p-col-12 p-md-3">
                  <FormControl>
                    <InputLabel htmlFor="notification-schedule-label">{Translate('Recurrency Type')}</InputLabel>
                    <Select
                      value={currentUserNotification.notificationScheduleTypeId ? currentUserNotification.notificationScheduleTypeId : -1}
                      onChange={(e) => this.handleChange('notificationScheduleTypeId', e.target.value)}
                      inputProps={{
                        name: 'notificationScheduleType',
                        id: 'notification-schedule-label'
                      }}>
                      {notificationScheduleTypeDropdown.map(m => <MenuItem key={m.value + 'notShedType'} value={m.value}>{m.label}</MenuItem>)}
                    </Select>
                  </FormControl>
                </div>
                {isFrequencyButtonDisabled ? oneTimeExecutionElement : globalFrequencyElement}
              </div>
            </div>


            {/* Daily frequency container */}
            {isFrequencyButtonDisabled ? null : dailyFrequencyContainer}
            {caretakers && caretakers.length > 0 ?
              <div className="p-grid p-fluid p-md-12">
                <div className="p-col-12 p-md-6">
                  <FormControl>
                    <InputLabel htmlFor="caretaker-user-label">{Translate('SendNotification')}</InputLabel>
                    <Select
                      value={currentUserNotification.caretakerUserId ? currentUserNotification.caretakerUserId : ''}
                      onChange={(e) => this.handleChange('caretakerUserId', e.target.value)}
                      inputProps={{
                        name: 'caretakerUser',
                        id: 'caretaker-user-label'
                      }}>
                      {caretakers.map(m => <MenuItem key={m.value + 'caretakerId'} value={m.value}>{m.label}</MenuItem>)}
                    </Select>
                  </FormControl>
                </div>
                {currentUserNotification && currentUserNotification.caretakerUserId && currentUserNotification.caretakerUserId > 0 ?
                  <div className="p-col-12 p-md-6">
                    <FormControl>
                      <InputLabel htmlFor="minutes-intake-label">{Translate('IfItsNotTaken')}</InputLabel>
                      <Select
                        value={currentUserNotification.minutesForIntake ? currentUserNotification.minutesForIntake : ''}
                        onChange={(e) => this.handleChange('minutesForIntake', e.target.value)}
                        inputProps={{
                          name: 'minutesForIntake',
                          id: 'minutes-intake-label'
                        }}>
                        {minutesForIntake.map(m => <MenuItem key={m.value + 'minutesForIntake'} value={m.value}>{m.label}</MenuItem>)}
                      </Select>
                    </FormControl>
                  </div>
                  : null}
              </div>
              : null}
            {/* Notes and summary container */}
            <div className="p-grid p-fluid p-md-12">
              <div className="p-col-12 p-md-12" >
                <div>
                  <TextField
                    autoComplete="off"
                    label={Translate('Notes')}
                    type="text"
                    value={currentUserNotification.description ? currentUserNotification.description : ''}
                    onChange={(e) => this.handleChange('description', e.target['value'])}
                    margin="none"
                  />
                </div>
              </div>
              <div className="p-col-12 p-md-12">
                <label>{Translate("Summary")}:&nbsp;</label>
                {this.state.summaryContent}
              </div>
            </div>
          </div>
        </Modal.DialogContent>
        <Modal.DialogActions>
          <div>
            <Button variant="contained" size="small" onClick={this.handleCancelButton} style={{ marginRight: '10px' }}>
              <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
              {Translate('Cancel')}
            </Button>
            <Button variant="contained" size="small" color="primary" onClick={this.handleSaveButton}>
              <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
              {Translate('Save')}
            </Button>
          </div>
        </Modal.DialogActions>
      </Dialog>
    )
  }
}

export default UserNotificationAddEditDialog;